import SVGAddToBasket from 'themesvg/add-to-basket.svg?inline';
import SVGAdd from 'themesvg/add.svg?inline';
import SVGArrowDown from 'themesvg/arrow-down.svg?inline';
import SVGArrowOpen from 'themesvg/arrow-open.svg?inline';
import SVGArrowUp from 'themesvg/arrow-up.svg?inline';
import SVGBigGreenArrow from 'themesvg/big-green-arrow.svg?inline';
import SVGCardPayment from 'themesvg/card-payment.svg?inline';
import SVGCategoryAllButcher from 'themesvg/category-all-butcher.svg?inline';
import SVGCategoryAllNegishi from 'themesvg/category-all-negishi.svg?inline';
import SVGCategoryAll from 'themesvg/category-all.svg?inline';
import SVGCategoryAngrychicken from 'themesvg/category-angrychicken.svg?inline';
import SVGCategoryBeer from 'themesvg/category-beer.svg?inline';
import SVGCategoryBurgersDouble from 'themesvg/category-burgers-double.svg?inline';
import SVGCategoryBurgersSaucy from 'themesvg/category-burgers-saucy.svg?inline';
import SVGCategoryBurgers from 'themesvg/category-burgers.svg?inline';
import SVGCategoryButcher from 'themesvg/category-butcher.svg?inline';
import SVGCategoryChicken from 'themesvg/category-chicken.svg?inline';
import SVGCategoryCocktailLong from 'themesvg/category-cocktail-long.svg?inline';
import SVGCategoryCocktailMedium from 'themesvg/category-cocktail-medium.svg?inline';
import SVGCategoryCocktailShort from 'themesvg/category-cocktail-short.svg?inline';
import SVGCategoryCoffee from 'themesvg/category-coffee.svg?inline';
import SVGCategoryComboButcher from 'themesvg/category-combo-butcher.svg?inline';
import SVGCategoryComboNegishi from 'themesvg/category-combo-negishi.svg?inline';
import SVGCategoryComboNooch from 'themesvg/category-combo-nooch.svg?inline';
import SVGCategoryComboPoke from 'themesvg/category-combo-poke.svg?inline';
import SVGCategoryCurries from 'themesvg/category-curries.svg?inline';
import SVGCategoryDessert from 'themesvg/category-dessert.svg?inline';
import SVGCategoryDiscounted from 'themesvg/category-discounted.svg?inline';
import SVGCategoryDrinks from 'themesvg/category-drinks.svg?inline';
import SVGCategoryDumplingbrothers from 'themesvg/category-dumplingbrothers.svg?inline';
import SVGCategoryDumplings from 'themesvg/category-dumplings.svg?inline';
import SVGCategoryExtras from 'themesvg/category-extras.svg?inline';
import SVGCategoryFavorites from 'themesvg/category-favorites.svg?inline';
import SVGCategoryFries from 'themesvg/category-fries.svg?inline';
import SVGCategoryHouseCraftDrink from 'themesvg/category-house-craft-drink.svg?inline';
import SVGCategoryKoreanFavorites from 'themesvg/category-korean-favorites.svg?inline';
import SVGCategoryLolaskitchen from 'themesvg/category-lolaskitchen.svg?inline';
import SVGCategoryLunchNegishi from 'themesvg/category-lunch-negishi.svg?inline';
import SVGCategoryLunchNooch from 'themesvg/category-lunch-nooch.svg?inline';
import SVGCategoryMissmiu from 'themesvg/category-missmiu.svg?inline';
import SVGCategoryNegishi from 'themesvg/category-negishi.svg?inline';
import SVGCategoryNooch from 'themesvg/category-nooch.svg?inline';
import SVGCategoryNotFound from 'themesvg/category-not-found.svg?inline';
import SVGCategoryPokeBowls from 'themesvg/category-poke-bowls.svg?inline';
import SVGCategoryPokenation from 'themesvg/category-pokenation.svg?inline';
import SVGCategoryRiceDish from 'themesvg/category-rice-dish.svg?inline';
import SVGCategorySalads from 'themesvg/category-salads.svg?inline';
import SVGCategorySauce from 'themesvg/category-sauce.svg?inline';
import SVGCategorySlides from 'themesvg/category-slides.svg?inline';
import SVGCategorySoupNoodles from 'themesvg/category-soup-noodles.svg?inline';
import SVGCategorySoup from 'themesvg/category-soup.svg?inline';
import SVGCategorySpecial from 'themesvg/category-special.svg?inline';
import SVGCategorySpeed from 'themesvg/category-speed.svg?inline';
import SVGCategoryStarters from 'themesvg/category-starters.svg?inline';
import SVGCategorySushiPlates from 'themesvg/category-sushi-plates.svg?inline';
import SVGCategorySushi from 'themesvg/category-sushi.svg?inline';
import SVGCategoryTea from 'themesvg/category-tea.svg?inline';
import SVGCategoryVegan from 'themesvg/category-vegan.svg?inline';
import SVGCategoryVegi from 'themesvg/category-vegi.svg?inline';
import SVGCategoryWine from 'themesvg/category-wine.svg?inline';
import SVGCircleChevronDown from 'themesvg/circle-chevron-down.svg?inline';
import SVGCircleChevronLeft from 'themesvg/circle-chevron-left.svg?inline';
import SVGCircleChevronRight from 'themesvg/circle-chevron-right.svg?inline';
import SVGCircleChevronUp from 'themesvg/circle-chevron-up.svg?inline';
import SVGClimateNeutral from 'themesvg/climate-neutral.svg?inline';
import SVGClock from 'themesvg/clock.svg?inline';
import SVGCopy from 'themesvg/copy.svg?inline';
import SVGCross from 'themesvg/cross.svg?inline';
import SVGDelivery from 'themesvg/delivery.svg?inline';
import SVGEditAdditional from 'themesvg/edit-additional.svg?inline';
import SVGEdit from 'themesvg/edit.svg?inline';
import SVGFilter from 'themesvg/filter.svg?inline';
import SVGInfo from 'themesvg/info.svg?inline';
import SVGLocation from 'themesvg/location.svg?inline';
import SVGMidCircleChevronDown from 'themesvg/mid-circle-chevron-down.svg?inline';
import SVGMidCircleChevronLeft from 'themesvg/mid-circle-chevron-left.svg?inline';
import SVGMidCircleChevronRight from 'themesvg/mid-circle-chevron-right.svg?inline';
import SVGMidCircleChevronUp from 'themesvg/mid-circle-chevron-up.svg?inline';
import SVGPaymentIconApplePay from 'themesvg/payment-icon-apple-pay.svg?inline';
import SVGPaymentIconDinersClub from 'themesvg/payment-icon-diners-club.svg?inline';
import SVGPaymentIconDiscover from 'themesvg/payment-icon-discover.svg?inline';
import SVGPaymentIconFwg from 'themesvg/payment-icon-fwg.svg?inline';
import SVGPaymentIconGooglePay from 'themesvg/payment-icon-google-pay.svg?inline';
import SVGPaymentIconJcb from 'themesvg/payment-icon-jcb.svg?inline';
import SVGPaymentIconLunchCheck from 'themesvg/payment-icon-lunch-check.svg?inline';
import SVGPaymentIconMaestro from 'themesvg/payment-icon-maestro.svg?inline';
import SVGPaymentIconMastercard from 'themesvg/payment-icon-mastercard.svg?inline';
import SVGPaymentIconPostFinance from 'themesvg/payment-icon-post-finance.svg?inline';
import SVGPaymentIconSamsungPay from 'themesvg/payment-icon-samsung-pay.svg?inline';
import SVGPaymentIconSamsungWallet from 'themesvg/payment-icon-samsung-wallet.svg?inline';
import SVGPaymentIconTwint from 'themesvg/payment-icon-twint.svg?inline';
import SVGPaymentIconUnionPay from 'themesvg/payment-icon-union-pay.svg?inline';
import SVGPaymentIconVisa from 'themesvg/payment-icon-visa.svg?inline';
import SVGPaymentIcons from 'themesvg/payment-icons.svg?inline';
import SVGPaymentSelectDatatrans from 'themesvg/payment-select-datatrans.svg?inline';
import SVGPaymentSelectSelfordering from 'themesvg/payment-select-selfordering.svg?inline';
import SVGPaymentSelectTwint from 'themesvg/payment-select-twint.svg?inline';
import SVGPlateCutlery from 'themesvg/plate-cutlery.svg?inline';
import SVGReset from 'themesvg/reset.svg?inline';
import SVGSauce from 'themesvg/sauce.svg?inline';
import SVGScanBarcode from 'themesvg/scan-barcode.svg?inline';
import SVGScanIllustrationPhoneSmall from 'themesvg/scan-illustration-phone-small.svg?inline';
import SVGScanIllustrationPhone from 'themesvg/scan-illustration-phone.svg?inline';
import SVGScanIllustration from 'themesvg/scan-illustration.svg?inline';
import SVGScanPager from 'themesvg/scan-pager.svg?inline';
import SVGSmallCheckmark from 'themesvg/small-checkmark.svg?inline';
import SVGSpice from 'themesvg/spice.svg?inline';
import SVGSticks from 'themesvg/sticks.svg?inline';
import SVGSubstract from 'themesvg/substract.svg?inline';
import SVGTakeaway from 'themesvg/takeaway.svg?inline';
import SVGTrash from 'themesvg/trash.svg?inline';
import SVGVoucher from 'themesvg/voucher.svg?inline';
import SVGWarningTriangle from 'themesvg/warning-triangle.svg?inline';

export default {
	SVGAddToBasket,
	SVGAdd,
	SVGArrowDown,
	SVGArrowOpen,
	SVGArrowUp,
	SVGBigGreenArrow,
	SVGCardPayment,
	SVGCategoryAllButcher,
	SVGCategoryAllNegishi,
	SVGCategoryAll,
	SVGCategoryAngrychicken,
	SVGCategoryBeer,
	SVGCategoryBurgersDouble,
	SVGCategoryBurgersSaucy,
	SVGCategoryBurgers,
	SVGCategoryButcher,
	SVGCategoryChicken,
	SVGCategoryCocktailLong,
	SVGCategoryCocktailMedium,
	SVGCategoryCocktailShort,
	SVGCategoryCoffee,
	SVGCategoryComboButcher,
	SVGCategoryComboNegishi,
	SVGCategoryComboNooch,
	SVGCategoryComboPoke,
	SVGCategoryCurries,
	SVGCategoryDessert,
	SVGCategoryDiscounted,
	SVGCategoryDrinks,
	SVGCategoryDumplingbrothers,
	SVGCategoryDumplings,
	SVGCategoryExtras,
	SVGCategoryFavorites,
	SVGCategoryFries,
	SVGCategoryHouseCraftDrink,
	SVGCategoryKoreanFavorites,
	SVGCategoryLolaskitchen,
	SVGCategoryLunchNegishi,
	SVGCategoryLunchNooch,
	SVGCategoryMissmiu,
	SVGCategoryNegishi,
	SVGCategoryNooch,
	SVGCategoryNotFound,
	SVGCategoryPokeBowls,
	SVGCategoryPokenation,
	SVGCategoryRiceDish,
	SVGCategorySalads,
	SVGCategorySauce,
	SVGCategorySlides,
	SVGCategorySoupNoodles,
	SVGCategorySoup,
	SVGCategorySpecial,
	SVGCategorySpeed,
	SVGCategoryStarters,
	SVGCategorySushiPlates,
	SVGCategorySushi,
	SVGCategoryTea,
	SVGCategoryVegan,
	SVGCategoryVegi,
	SVGCategoryWine,
	SVGCircleChevronDown,
	SVGCircleChevronLeft,
	SVGCircleChevronRight,
	SVGCircleChevronUp,
	SVGClimateNeutral,
	SVGClock,
	SVGCopy,
	SVGCross,
	SVGDelivery,
	SVGEditAdditional,
	SVGEdit,
	SVGFilter,
	SVGInfo,
	SVGLocation,
	SVGMidCircleChevronDown,
	SVGMidCircleChevronLeft,
	SVGMidCircleChevronRight,
	SVGMidCircleChevronUp,
	SVGPaymentIconApplePay,
	SVGPaymentIconDinersClub,
	SVGPaymentIconDiscover,
	SVGPaymentIconFwg,
	SVGPaymentIconGooglePay,
	SVGPaymentIconJcb,
	SVGPaymentIconLunchCheck,
	SVGPaymentIconMaestro,
	SVGPaymentIconMastercard,
	SVGPaymentIconPostFinance,
	SVGPaymentIconSamsungPay,
	SVGPaymentIconSamsungWallet,
	SVGPaymentIconTwint,
	SVGPaymentIconUnionPay,
	SVGPaymentIconVisa,
	SVGPaymentIcons,
	SVGPaymentSelectDatatrans,
	SVGPaymentSelectSelfordering,
	SVGPaymentSelectTwint,
	SVGPlateCutlery,
	SVGReset,
	SVGSauce,
	SVGScanBarcode,
	SVGScanIllustrationPhoneSmall,
	SVGScanIllustrationPhone,
	SVGScanIllustration,
	SVGScanPager,
	SVGSmallCheckmark,
	SVGSpice,
	SVGSticks,
	SVGSubstract,
	SVGTakeaway,
	SVGTrash,
	SVGVoucher,
	SVGWarningTriangle
}